import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { IconButton } from "@mui/material";
import React from "react";

export const CustomStatusPanel = ({ handleNew }: { handleNew: () => void }) => (
	<IconButton onClick={handleNew} color="primary" style={{ marginLeft: -15 }}>
		<PlaylistAddIcon style={{ width: 30, height: 30 }} />
	</IconButton>
);
